module.exports = __webpack_public_path__ + "static/media/f_lipshape_downturned.600bf025.png";